










import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { TimeTypes } from '@/config/map.conf';

/**
 * 时长输入组件
 *
 * @author xiaokunyu
 * @date 01/11/2019
 */
@Component
export default class TimeInput extends Vue {
    @Prop({ default: 5 })
    time: number;
    @Prop({ default: 'MINUTE' })
    unit: string;
    @Prop({ default: false })
    disabled: Boolean;

    currTime: number = null;
    currUnit: string = '';
    timeTypes: CommonTypes.mapObject = TimeTypes;

    created() {
        this.currTime = this.time;
        this.currUnit = this.unit;
    }

    @Watch('time')
    onTimeChanged(val) {
        if (val) {
            this.currTime = val;
        }
    }
    @Watch('unit')
    onUnitChanged(val) {
        if (val) {
            this.currUnit = val;
        }
    }
    @Watch('currTime')
    onCurrTimeChanged(val) {
        this.$emit('update:time', val);
    }
    @Watch('currUnit')
    onCurrUnitChanged(val) {
        this.$emit('update:unit', val);
    }
}
